import { useState } from "react";
import {
  IFilterComboPropVerificacion,
  InitialFilterComboPropVerificacion,
} from "../../Interfaces/ListaVerificacion/PropiedadesVerificacion/IPropiedadesVerificacion";
import PropiedadesVerificacionService from "../../services/ListaVerificacion/PropiedadesVerificacionService";
import { IComboBoxOption } from "@fluentui/react";

export const useComboPropiedadesVerificacion = () => {
  const [filter, setFilter] = useState<IFilterComboPropVerificacion>(
    InitialFilterComboPropVerificacion
  );

  const [
    dataComboPropiedadesVerificacion,
    setDataComboPropiedadesVerificacion,
  ] = useState<IComboBoxOption[]>([]);

  const postComboPropiedadesVerificacion = (gvId: string) => {
    PropiedadesVerificacionService.PostComboPropiedadesPorGrupo({search:'',grupoVerificiacionId:gvId}).then(
      (res) => {
        if (res.status === 200) {
          setDataComboPropiedadesVerificacion(res.data);
        }
      }
    );
  };
  const limpiarCheckBox = () =>{
    setDataComboPropiedadesVerificacion([])
  }

  return {
    postComboPropiedadesVerificacion,
    dataComboPropiedadesVerificacion,
    limpiarCheckBox
  };
};
